module.exports = __webpack_public_path__ + "img/speed-test.bbf221ab.svg";